module.exports = __webpack_public_path__ + "images/emoji/school.217e2d3f3dd769edd08e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/school.png
// module id = EKiU
// module chunks = 2